const GOOGLE_REGION_BLOCKLIST = new Set(["NA", "ZZ"]);

export interface ParsedStreetAddress {
  street: string;
  postalCode: string;
  city: string;
  country: string;
}

export function toGoogleLanguage(language: string): string {
  return language.startsWith("en") ? "en" : "de";
}

export function toGoogleRegionCode(country: string): string | undefined {
  const iso = country.trim().toUpperCase();
  if (!iso || iso.length !== 2 || GOOGLE_REGION_BLOCKLIST.has(iso)) {
    return undefined;
  }
  return iso;
}

export function parseAddressComponents(
  components: google.maps.places.AddressComponent[],
): ParsedStreetAddress {
  const get = (type: string, useShort = false) => {
    const component = components.find((entry) => entry.types.includes(type));
    if (!component) return "";
    return useShort
      ? (component.shortText ?? component.longText ?? "")
      : (component.longText ?? component.shortText ?? "");
  };

  const route = get("route");
  const streetNumber = get("street_number");
  const street = [route, streetNumber].filter(Boolean).join(" ").trim();
  const city =
    get("locality") ||
    get("postal_town") ||
    get("administrative_area_level_2") ||
    get("sublocality");
  const postalCode = get("postal_code");
  const country = get("country", true);

  return { street, postalCode, city, country };
}
